import { motion } from "motion/react";
import { useCustomNavigation } from "@/hooks/useCustomNavigation";

interface AnimatedPageProps {
  children: React.ReactNode;
}

const AnimatedPage: React.FC<AnimatedPageProps> = ({ children }) => {
  const { isBack } = useCustomNavigation();

  return (
    <motion.div
      initial={{ x: isBack ? "-100%" : "100%" }}
      animate={{
        x: 0,
      }}
      exit={{
        x: isBack ? "100%" : "-100%",
        transition: { ease: "easeOut" },
      }}
      transition={{ duration: 0.3, ease: "circOut" }}
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
